import protobuf from 'protobufjs'
import messageTypeDefs from './notification.proto.json'

export const clientRoot = protobuf.Root.fromJSON(messageTypeDefs)
